import { useState } from 'react';
import { FileState } from '@/hooks/useFileUpload';

export const FILE_UPLOAD_FLAGS = {
    INITIALIZED: 0,
    LOADING: 1,
    UPLOADED: 2,
};

export function useFulfillOrderModal() {
    const [flag, setFlag] = useState(FILE_UPLOAD_FLAGS.INITIALIZED);
    const [fileUploadProgress, setFileUploadProgress] = useState(0);
    const [fileData, setFileData] = useState(undefined);
    const [fileName, setFileName] = useState('');

    const resetDownload = () => {
        setFlag(FILE_UPLOAD_FLAGS.INITIALIZED);
        setFileData(undefined);
        setFileUploadProgress(0);
    };

    const uploadingFile = (pickedFiles: FileState[]) => {
        const fileState = pickedFiles[0];
        if (!fileState) return;
        setFileName(fileState.file.name);
        if (fileState.status === 'uploading') {
            setFlag(FILE_UPLOAD_FLAGS.LOADING);
        } else if (fileState.status === 'success') {
            setFlag(FILE_UPLOAD_FLAGS.UPLOADED);
            const fileData: any = { name: fileState.file.name, src: fileState.url };
            setFileData(fileData);
        }
    };

    const addFile = () => {
        setFlag(FILE_UPLOAD_FLAGS.INITIALIZED);
        setFileUploadProgress(0);
        setFileData(undefined);
        setFileName('');
    };

    const onUploadProgress = (payload: any) => {
        setFlag(FILE_UPLOAD_FLAGS.LOADING);
        setFileName(payload.name);
        setFileUploadProgress(payload.progress);
    };

    return {
        flag,
        fileUploadProgress,
        fileData,
        fileName,
        resetDownload,
        uploadingFile,
        addFile,
        onUploadProgress,
    };
}
